import { registerTileComponentInfo } from "./tile-component-info";
import { registerTileContentInfo } from "./tile-content-info";
import PlaceholderTileComponent from "../../components/tiles/placeholder/placeholder-tile";
import { UnknownContentModel } from "./unknown-content";
import { kUnknownTileType } from "./unknown-types";
export function defaultContent() {
    return UnknownContentModel.create();
}
registerTileContentInfo({
    type: kUnknownTileType,
    modelClass: UnknownContentModel,
    defaultContent
});
registerTileComponentInfo({
    type: kUnknownTileType,
    Component: PlaceholderTileComponent,
    tileEltClass: "placeholder-tile",
    tileHandlesOwnSelection: true
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidW5rbm93bi1jb250ZW50LXJlZ2lzdHJhdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9tb2RlbHMvdGlsZXMvdW5rbm93bi1jb250ZW50LXJlZ2lzdHJhdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUseUJBQXlCLEVBQUUsTUFBTSx1QkFBdUIsQ0FBQztBQUNsRSxPQUFPLEVBQUUsdUJBQXVCLEVBQUUsTUFBTSxxQkFBcUIsQ0FBQztBQUM5RCxPQUFPLHdCQUF3QixNQUFNLHFEQUFxRCxDQUFDO0FBQzNGLE9BQU8sRUFBd0IsbUJBQW1CLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUM5RSxPQUFPLEVBQUUsZ0JBQWdCLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUVuRCxNQUFNLFVBQVUsY0FBYztJQUM1QixPQUFPLG1CQUFtQixDQUFDLE1BQU0sRUFBRSxDQUFDO0FBQ3RDLENBQUM7QUFFRCx1QkFBdUIsQ0FBQztJQUN0QixJQUFJLEVBQUUsZ0JBQWdCO0lBQ3RCLFVBQVUsRUFBRSxtQkFBbUI7SUFDL0IsY0FBYztDQUNmLENBQUMsQ0FBQztBQUVILHlCQUF5QixDQUFDO0lBQ3hCLElBQUksRUFBRSxnQkFBZ0I7SUFDdEIsU0FBUyxFQUFFLHdCQUF3QjtJQUNuQyxZQUFZLEVBQUUsa0JBQWtCO0lBQ2hDLHVCQUF1QixFQUFFLElBQUk7Q0FDOUIsQ0FBQyxDQUFDIn0=